import {
  ISmartCanvasClickedItemEvent,
  ISmartCanvasOptions,
  ISmartCanvasSelectionArea,
} from '../../../shared/models/interfaces/smart-canvas.interface';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { WordDataTypeEnum } from '../../../shared/models/enums/word-data-type.enum';
import { GroupConfiguration, GroupConfigurationKey } from '../../../shared/models/group-keys.model';
import { IFilePageAndWords, IFileProcessedWord } from '../../../shared/models/interfaces/files.interface';
import { EventEmitterService } from '../../../shared/services/event-emitter.service';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { IPageDimensions } from 'src/modules/shared/models/interfaces/page-dimensions.interface';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { GeneratorsUtility } from 'src/modules/shared/utilities/generators';

@Component({
  selector: 'hcr-smart-canvas-group-key-selection',
  templateUrl: './smart-canvas-group-key-selection.component.html',
  styleUrls: ['./smart-canvas-group-key-selection.component.sass'],
})
export class SmartCanvasGroupKeySelectionComponent implements OnInit {
  @Input() selectedGroupConfiguration: GroupConfiguration;
  @Input() selectedFilePagesAndWords: IFilePageAndWords[];
  @Input() stagePageSizes: IPageDimensions[];
  @Input() smartCanvasOptions: ISmartCanvasOptions;
  @Input() konvaStage: any; //Konva.Stage;

  public show = false;
  public position = { x: 0, y: 0 };
  public activeSelectionArea: ISmartCanvasSelectionArea;
  public isOnHover = false;
  public wordDataTypeEnum = WordDataTypeEnum;

  public icons = {
    arrow: faCaretRight,
    plus: faPlus,
  };

  @HostListener('mouseenter')
  public mouseenterListener(): void {
    this.isOnHover = true;
  }

  @HostListener('mouseleave')
  public mouseleaveListener(): void {
    this.isOnHover = false;

    if (!this.activeSelectionArea.fixedTooltipPosition) {
      this.hide();
    }
  }

  constructor(private _eventEmitterService: EventEmitterService) {}

  public groupKeyClicked(event: MouseEvent, groupKey: GroupConfigurationKey): boolean {
    event.stopPropagation();

    this._eventEmitterService
      .get<ISmartCanvasClickedItemEvent>('clicked-value')
      .emit({ groupKey: groupKey, selectedArea: this.activeSelectionArea });

    this.hide();
    this._eventEmitterService.get('hide-selection-area').emit();

    return false;
  }

  public truncateText(text: string): string {
    return text.length > 80 ? `${text.slice(0, 80)}...` : text;
  }

  public hide(): void {
    this.konvaStage.off('mousemove.groupkeytooltip');
    this.show = false;
  }

  public createGroupKey(event: MouseEvent): void {
    const label = this.getProcessedTypes()[0]
      ? this.getFullText().replace(this.getProcessedTypes()[0].originalValue, '').replace(':', '')
      : this.getFullText();

    this.groupKeyClicked(
      event,
      new GroupConfigurationKey({
        key: GeneratorsUtility.generateIdFromString(label),
        label: label,
        type: this.getProcessedTypes()[0]?.valueType || WordDataTypeEnum.text,
        canReceiveConstant: false,
        isCustom: true,
      })
    );
  }

  public getProcessedTypes(): IFileProcessedWord[] {
    return this.activeSelectionArea.polygonsInside.flatMap((poly) => poly.content.processedValues);
  }

  /**
   * Pega a lista de palavras que foram processadas anteriormente e que possuem algum tipo associado.
   */
  public getProcessedValuesFromType(keyType: string): IFileProcessedWord[] {
    return this.getProcessedTypes().filter((value) => WordDataTypeEnum[value.valueType] === keyType);
  }

  /**
   * Retorna o texto concatenado das palavras selecionadas.
   */
  public getFullText(): string {
    return this.activeSelectionArea.polygonsInside.flatMap((p) => p.content.text).join(' ');
  }

  ngOnInit(): void {
    this._eventEmitterService.get<ISmartCanvasSelectionArea>('hide-group-key-selection').subscribe(() => {
      if (!this.isOnHover) {
        this.hide();
      }
    });

    this._eventEmitterService.get<ISmartCanvasSelectionArea>('show-group-key-selection').subscribe((area) => {
      this.show = true;
      this.activeSelectionArea = area;

      if (!area.fixedTooltipPosition) {
        this.konvaStage.off('mousemove.groupkeytooltip').on('mousemove.groupkeytooltip', (opt) => {
          if (!this.isOnHover && opt.target.attrs.word) {
            this.position = {
              x: <number>opt.evt.offsetX - <number>opt.target.getStage().content.offsetLeft,
              y: opt.target.getClientRect().y + opt.target.getClientRect().height - 10,
              // y: <number>opt.target.getStage().y() + area.boundingBox[5] * opt.target.getStage().getClientRect().height,
            };
          }
        });
      } else {
        this.konvaStage;
        this.position = {
          x: area.tooltipPosition.x,
          y: area.tooltipPosition.y,
        };
      }
    });
  }
}
